import styled from 'styled-components';
import FlexContainer from 'common/components/atoms/FlexContainer';

const MachineContainer = styled(FlexContainer).attrs({
  justifyContent: 'space-around',
})`
  margin-top: 80px;
`;
export default styled(MachineContainer)``;
